import type { SchemaField } from '@cli-types/core-engine/schema.js'

export function collectRelationshipFields(
  fields: SchemaField[],
  _tabFieldNames: Set<string>
): SchemaField[] {
  const result: SchemaField[] = []
  const seen = new Set<string>()
  function collect(fieldsToCheck: SchemaField[]): void {
    for (const f of fieldsToCheck) {
      if (f.type === 'relationship' && f.relationship && !seen.has(f.name)) {
        seen.add(f.name)
        result.push(f)
      }
      if ((f.type === 'group' || f.type === 'section') && f.fields) collect(f.fields)
      if (f.type === 'tabs' && f.tabs) {
        for (const tab of f.tabs) {
          if (tab.fields) collect(tab.fields)
        }
      }
    }
  }
  collect(fields)
  return result
}
